import type { NextPage } from 'next';
import { NextSeo } from 'next-seo';

import { SUPPORTED_CHAINS } from '@/constants/chain';

import { DEFAULT_SEO_CONFIG, ROOT_URL_PRODUCTION } from '../../next-seo.config';
import { SwapTokens } from '../components/SwapTokens';
import { routes } from '../utils/routes';

const SWAP_TOKENS_TITLE = 'Swap tokens and exchange crypto with no fees | Matcha DEX aggregator';
const SWAP_TOKENS_DESCRIPTION = `Swap tokens with zero fees across ${SUPPORTED_CHAINS.length} crypto networks. Instantly trade over 9 million tokens with deep aggregated liquidity from 130+ exchanges!`;

const SwapTokensPage: NextPage = () => {
  return (
    <>
      <NextSeo
        {...DEFAULT_SEO_CONFIG}
        title={SWAP_TOKENS_TITLE}
        description={SWAP_TOKENS_DESCRIPTION}
        canonical={`${ROOT_URL_PRODUCTION}${routes.SWAP_TOKENS}`}
        openGraph={{
          images: [
            {
              url: `${ROOT_URL_PRODUCTION}/images/og/social-swap-tokens-banner.jpg`,
              width: 1200,
              height: 630,
              alt: 'Matcha',
            },
          ],
        }}
        additionalMetaTags={[
          {
            name: 'twitter:title',
            content: SWAP_TOKENS_TITLE,
          },
          {
            name: 'twitter:description',
            content: SWAP_TOKENS_DESCRIPTION,
          },
          {
            name: 'twitter:image',
            content: `${ROOT_URL_PRODUCTION}/images/og/social-swap-tokens-banner.jpg`,
          },
          {
            name: 'twitter:url',
            content: `${ROOT_URL_PRODUCTION}${routes.SWAP_TOKENS}`,
          },
        ]}
      />
      <SwapTokens />
    </>
  );
};

export default SwapTokensPage;
